import React from "react";
import PropTypes from "prop-types";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import Tooltip from "@material-ui/core/Tooltip";

import DeleteSubmittalButton from "./DeleteSubmittalButton";
import {
  Check,
  VerticalAlignWrapper,
} from "../../../SubmittalsManager/RequirementsGrid/SubmittalsTable/components";
import { renderFilename } from "../../../SubmittalsManager/RequirementsGrid/SubmittalsTable/Table";

// A file can't be edited: to change one, upload the new file and delete the old
export function actionIconsBuilder(onDeleteClick) {
  const ActionIconsFormatter = ({ row }) => (
    <DeleteSubmittalButton onSubmit={onDeleteClick} submittalFile={row} />
  );

  ActionIconsFormatter.propTypes = {
    row: PropTypes.shape({}),
  };

  const ActionIconsProvider = props => {
    return (
      <DataTypeProvider
        formatterComponent={ActionIconsFormatter}
        {...props}
        for={["actionIcons"]}
      />
    );
  };
  return ActionIconsProvider;
}

// The tick is the only approval control: clicking it approves the file, or
// removes the approval when the file already is the approval. onApprove gets
// the submittal to approve (null to remove it) and the clicked row.
export const approveTypeBuilder = (specRequirement, onApprove, disabled) => {
  const canApprove = onApprove && !disabled;

  const ApproveFormatter = ({ row }) => {
    const isApproved = row.id === specRequirement.submittalApprovedId;
    const toggleApproval = () => onApprove(isApproved ? null : row, row);
    const onClick = canApprove ? toggleApproval : null;
    return (
      <VerticalAlignWrapper>
        {/* Check drops the ref Tooltip needs to anchor, so a span holds it */}
        <Tooltip title={isApproved ? "Remove Approval" : "Approve"}>
          <span style={{ display: "inline-flex" }}>
            <Check isApproved={isApproved} onClick={onClick} />
          </span>
        </Tooltip>
      </VerticalAlignWrapper>
    );
  };

  ApproveFormatter.propTypes = {
    row: PropTypes.shape({}),
  };

  const ApproveTypeProvider = props => (
    <DataTypeProvider
      formatterComponent={ApproveFormatter}
      {...props}
      for={["approved"]}
    />
  );
  return ApproveTypeProvider;
};

export const filenameTypeBuilder = () => {
  const FilenameFormatter = ({ row }) => renderFilename(row);
  const ApproveTypeProvider = props => (
    <DataTypeProvider
      formatterComponent={FilenameFormatter}
      {...props}
      for={["file.filename"]}
    />
  );
  return ApproveTypeProvider;
};
